module.exports = __webpack_public_path__ + "static/media/alert-view.71869d39.svg";